import React from "react";

import Script from "dangerous-html/react";

import "../layout/footer.css";

const Footer: React.FC = () => {
  return (
    <div className="footer-container1">
      <footer className="footer">
        <div className="footer-decoration-top"></div>
        <div className="footer-container">
          <div className="footer-main">
            <div className="footer-brand">
              <div className="footer-brand-logo">
                <div className="footer-logo-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                      <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                      <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                      <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                      <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                      <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                    </g>
                  </svg>
                </div>
                <span className="footer-brand-name">Anuj Kumar Tiwari</span>
              </div>
              <p className="footer-brand-tagline">
                {" "}
                Architecting the Future of Cloud &amp; AI
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </p>
              <p className="footer-brand-description">
                {" "}
                Full Stack Architect specializing in Cloud Solutions and
                Generative AI. Over 18 years of experience delivering robust,
                secure, and scalable multi-tier cloud-native solutions.
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </p>
              <div className="footer-social">
                <a href="https://linkedin.com">
                  <div aria-label="LinkedIn" className="footer-social-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2a2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6M2 9h4v12H2z"></path>
                        <circle cx="4" cy="4" r="2"></circle>
                      </g>
                    </svg>
                  </div>
                </a>
                <a href="https://github.com">
                  <div aria-label="GitHub" className="footer-social-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5c.08-1.25-.27-2.48-1-3.5c.28-1.15.28-2.35 0-3.5c0 0-1 0-3 1.5c-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.4 5.4 0 0 0 4 9c0 3.5 3 5.5 6 5.5c-.39.49-.68 1.05-.85 1.65S8.93 17.38 9 18v4"></path>
                        <path d="M9 18c-4.51 2-5-2-7-2"></path>
                      </g>
                    </svg>
                  </div>
                </a>
                <a href="https://twitter.com">
                  <div aria-label="Twitter" className="footer-social-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6c2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4c-.9-4.2 4-6.6 7-3.8c1.1 0 3-1.2 3-1.2"
                      ></path>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-sections">
              <div className="footer-column">
                <h3 className="footer-column-title">Expertise</h3>
                <ul className="footer-links">
                  <li className="footer-link-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9"
                      ></path>
                    </svg>
                    <a href="#cloud-architecture">
                      <div className="footer-link">
                        <span>
                          {" "}
                          Cloud Architecture
                          <span
                            dangerouslySetInnerHTML={{
                              __html: " ",
                            }}
                          />
                        </span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                        <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                        <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                        <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                        <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                        <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                      </g>
                    </svg>
                    <a href="#generative-ai">
                      <div className="footer-link">
                        <span>Generative AI</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                      ></path>
                    </svg>
                    <a href="#full-stack-development">
                      <div className="footer-link">
                        <span>
                          {" "}
                          Full Stack Development
                          <span
                            dangerouslySetInnerHTML={{
                              __html: " ",
                            }}
                          />
                        </span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                      ></path>
                    </svg>
                    <a href="#microservices">
                      <div className="footer-link">
                        <span>Microservices</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9"
                      ></path>
                    </svg>
                    <a href="#aws-solutions">
                      <div className="footer-link">
                        <span>AWS Solutions</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                      ></path>
                    </svg>
                    <a href="#security-architecture">
                      <div className="footer-link">
                        <span>
                          {" "}
                          Security Architecture
                          <span
                            dangerouslySetInnerHTML={{
                              __html: " ",
                            }}
                          />
                        </span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <h3 className="footer-column-title">Technologies</h3>
                <ul className="footer-links">
                  <li className="footer-link-item">
                    <a href="#java-spring">
                      <div className="footer-link">
                        <span>Java &amp; Spring Boot</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <a href="#python-fastapi">
                      <div className="footer-link">
                        <span>Python &amp; FastAPI</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <a href="#react-angular">
                      <div className="footer-link">
                        <span>React &amp; Angular</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <a href="#nodejs">
                      <div className="footer-link">
                        <span>Node.js</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <a href="#kafka">
                      <div className="footer-link">
                        <span>Apache Kafka</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <a href="#aws-bedrock">
                      <div className="footer-link">
                        <span>AWS Bedrock</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <h3 className="footer-column-title">Services</h3>
                <ul className="footer-links">
                  <li className="footer-link-item">
                    <a href="#architecture-consulting">
                      <div className="footer-link">
                        <span>
                          {" "}
                          Architecture Consulting
                          <span
                            dangerouslySetInnerHTML={{
                              __html: " ",
                            }}
                          />
                        </span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <a href="#cloud-migration">
                      <div className="footer-link">
                        <span>Cloud Migration</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <a href="#ai-integration">
                      <div className="footer-link">
                        <span>AI Integration</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <a href="#devops-cicd">
                      <div className="footer-link">
                        <span>DevOps &amp; CI/CD</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <a href="#security-audit">
                      <div className="footer-link">
                        <span>Security Audit</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-link-item">
                    <a href="#team-mentoring">
                      <div className="footer-link">
                        <span>Team Mentoring</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <h3 className="footer-column-title">Contact</h3>
                <ul className="footer-contact">
                  <li className="footer-contact-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M17.97 9.304A8 8 0 0 0 2 10c0 4.69 4.887 9.562 7.022 11.468m12.356-4.842a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"></path>
                        <circle cx="10" cy="10" r="3"></circle>
                      </g>
                    </svg>
                    <span className="footer-contact-text">Noida, India</span>
                  </li>
                  <li className="footer-contact-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                      </g>
                    </svg>
                    <a href="mailto:anouj.kumar.tiwari@gmail.com?subject=">
                      <div className="footer-contact-link">
                        <span>
                          {" "}
                          anouj.kumar.tiwari@gmail.com
                          <span
                            dangerouslySetInnerHTML={{
                              __html: " ",
                            }}
                          />
                        </span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-contact-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                      ></path>
                    </svg>
                    <a href="tel:+918292109595">
                      <div className="footer-contact-link">
                        <span>
                          {" "}
                          +91 82921 09595
                          <span
                            dangerouslySetInnerHTML={{
                              __html: " ",
                            }}
                          />
                        </span>
                      </div>
                    </a>
                  </li>
                </ul>
                <div className="footer-cta">
                  <h4 className="footer-cta-title">Ready to Innovate?</h4>
                  <a href="#contact">
                    <div className="btn btn-primary">
                      <span>Get In Touch</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-certifications">
            <div className="footer-cert-item">
              <span className="footer-cert-label">Education</span>
              <span className="footer-cert-value">
                {" "}
                Master&apos;s in Informatics, University of Delhi
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
            </div>
            <div className="footer-cert-item">
              <span className="footer-cert-label">Experience</span>
              <span className="footer-cert-value">
                18+ Years in Full Stack &amp; Cloud
              </span>
            </div>
            <div className="footer-cert-item">
              <span className="footer-cert-label">Specialization</span>
              <span className="footer-cert-value">
                {" "}
                Cloud Architecture &amp; Generative AI
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <p className="footer-copyright">
                {" "}
                © 2025 Anuj Kumar Tiwari. All rights reserved. Created by Anuj
                Kumar Tiwari.
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </p>
              <nav className="footer-legal">
                <a href="#privacy">
                  <div className="footer-legal-link">
                    <span>Privacy Policy</span>
                  </div>
                </a>
                <span className="footer-legal-separator">|</span>
                <a href="#terms">
                  <div className="footer-legal-link">
                    <span>Terms of Service</span>
                  </div>
                </a>
                <span className="footer-legal-separator">|</span>
                <a href="#cookies">
                  <div className="footer-legal-link">
                    <span>Cookie Policy</span>
                  </div>
                </a>
              </nav>
            </div>
          </div>
        </div>
        <button aria-label="Scroll to top" className="footer-scroll-top">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
          >
            <path
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m5 12l7-7l7 7m-7 7V5"
            ></path>
          </svg>
        </button>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.footer-social-link, .footer-link, .footer-contact-link, .footer-legal-link, .footer-scroll-top {
  transition: none;
}
.footer-social-link:hover {
  transform: none;
}
.footer-scroll-top:hover {
  transform: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="footer-container4">
        <div className="footer-container5">
          <Script
            html={`<script defer data-name="footer-scroll-top">
(function(){
  const scrollTopBtn = document.querySelector(".footer-scroll-top")

  window.addEventListener("scroll", () => {
    if (window.scrollY > 400) {
      scrollTopBtn.classList.add("visible")
    } else {
      scrollTopBtn.classList.remove("visible")
    }
  })

  scrollTopBtn.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  );
};

export default Footer;
